import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {GridColumn, Grid, GridNoRecords} from '@progress/kendo-react-grid';
import { withState } from './withState.js';
import OpenCell from "../cellWithEditing";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
const StatefullGrid = withState(Grid);


const columns = [
    { field: "articleGroup",         title: "Art.gr.", minWidth: 20 },
    { field: "articleCode",          title: "Art.nr.", minWidth: 30 },
    { field: "articleSize",          title: "Maat", minWidth: 30 },
    { field: "quantity",             title: "Aant.", minWidth: 30 },
    { field: "toStore",              title: "Naar", minWidth: 80 },
    { field: "description",          title: "Interne code", minWidth: 120,  minGridWidth: 900},
    { field: "price",                title: "Prijs", minWidth: 20, format:"{0:c}" },
];

//
// <GridColumn field="listNumberAndRemarks" title="Lijst"  />
// <GridColumn field="articleGroup" title="Art.gr." width={80} />
// <GridColumn field="articleCode" title="Art.nr." width={80} />
// <GridColumn field="articleSize" title="Maat" width={90} />
// <GridColumn field="quantity" title="Aant." width={80} />
// <GridColumn field="toStore" title="Naar"  width={120} />
// <GridColumn field="description" title="Interne code"   />
// <GridColumn field="price" title="Prijs"  width={140}  format="{0:c}" />

const ADJUST_PADDING = 4;
const COLUMN_MIN = 4;
class GridRejected extends React.Component {
    minGridWidth = 0;

    state = {
        visibleColumns: columns,
        setMinWidth: false,
        gridCurrent: 0,
        loadingText: "Records worden geladen"
    }
    constructor(props) {
        super(props);
        this.handlerNoRecords = this.handlerNoRecords.bind(this);
    }
    edit = (dataItem) => {
        this.setState({ productInEdit: this.cloneProduct(dataItem) });
    }
    handlerNoRecords() {
        this.setState({ loadingText: "Geen records gevonden" });
    }
    componentDidMount() {
        this.grid = document.querySelector('.k-grid');
        window.addEventListener('resize', this.handleResize);
        //columns.map(item => this.minGridWidth += item.minWidth);
        this.setState({
            gridCurrent: this.grid.offsetWidth,
            setMinWidth: this.grid.offsetWidth < this.minGridWidth
        });

        const currentVisibleColumns = columns.filter((c) => !(c.minGridWidth > this.grid.offsetWidth));
        if (currentVisibleColumns.length !== this.state.visibleColumns.length) {
            this.setState({
                visibleColumns: currentVisibleColumns
            });
        }
    }
    // setWidth = (minWidth) => {
    //     let width = this.state.setMinWidth ? minWidth :
    //         minWidth + (this.state.gridCurrent - this.minGridWidth) / columns.length;
    //     width = width < COLUMN_MIN ? width : width -= ADJUST_PADDING;
    //     return width;
    // }
    // handleResize = () => {
    //     const currentVisibleColumns = columns.filter((c) => !(c.minGridWidth > this.grid.offsetWidth));
    //     if (currentVisibleColumns.length !== this.state.visibleColumns.length) {
    //         this.setState({
    //             visibleColumns: currentVisibleColumns
    //         });
    //     }
    //     if (this.grid.offsetWidth < this.minGridWidth && !this.state.setMinWidth) {
    //         this.setState({
    //             setMinWidth: true
    //         });
    //     } else if (this.grid.offsetWidth > this.minGridWidth) {
    //         this.setState({
    //             gridCurrent: this.grid.offsetWidth,
    //             setMinWidth: false
    //         });
    //     }
    // }
    handleResize = () => {
        console.log(this.grid.offsetWidth);
        const currentVisibleColumns = columns.filter((c) => !(c.minGridWidth > this.grid.offsetWidth));
        if (currentVisibleColumns.length !== this.state.visibleColumns.length) {
            this.setState({
                visibleColumns: currentVisibleColumns
            });
        }
    }

    MyCustomCell = (props) => <OpenCell {...props} itemState={"rejected"} />
    render() {
        return (
            <div>
                <StatefullGrid handlerNoRecords={this.handlerNoRecords} group={'listNumberAndRemarks'} gridType={this.props.gridType}>

                    {
                        this.state.visibleColumns.map((column, index) => {
                            return <GridColumn field={column.field} title={column.title} key={index}   format={column.format} />;
                        })
                    }

                    <GridColumn
                        title=""
                        cell={this.MyCustomCell}
                    />
                    <GridNoRecords>
                    {this.state.loadingText}
                    </GridNoRecords>
                </StatefullGrid>
            </div>
        );
    }
}

export default GridRejected;
